import script from "./gallery.vue?vue&type=script&setup=true&lang=js"
export * from "./gallery.vue?vue&type=script&setup=true&lang=js"

import "./gallery.vue?vue&type=style&index=0&id=6ab5c74a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ab5c74a"]])

export default __exports__